import React from "react"
import * as S from "./custom-input.styles.jsx"
import PropTypes from "prop-types"

const CustomInput = ({
  size,
  InputProps,
  errors,
  name,
  customError,
  placeholder,
  register,
  required = false,
  ...otherProps
}) => {
  const getError = () => {
    if (errors && errors[name]) {
      if (customError) {
        return customError
      }
      return "This is a required field"
    }
  }

  return (
    <S.Wrapper
      color="secondary"
      required={required}
      placeholder={placeholder}
      InputProps={InputProps}
      size={size}
      fullWidth
      helperText={getError()}
      inputProps={{ ...register(name, { required: required }) }}
      {...otherProps}
    />
  )
}

CustomInput.propTypes = {
  required: PropTypes.bool,
  register: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
}

export default CustomInput
